import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import SvgMore from "@material-ui/icons/ExpandMore";
import InputAutoComplet from "../input/InputAutoComplet";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ReactSession } from "react-client-session";
import TextInput from "../input/TextInput";
import NumberInput from "../input/NumberInput";

const ReconciledReportView = ({
    ent,
    id,
    updateEvent
}) => {
    const [expand, setExpand] = useState(false);
    const [batchDataArray, setBatchDataArray] = useState([])
    const [rowEditObject, setRowEditObject] = useState(ent.reco_full_records)
    const axiosPrivate = useAxiosPrivate()

    const handleExpand = () => {
        setExpand(!expand);
    };
    const box_id = ReactSession.get("box_id")
    const APICall = (e, val, idx) => {
        setBatchDataArray([])
        setRowEditObject((current) =>
            current.map((value_x, index) =>
                index === idx
                    ? {
                        ...value_x,
                        medicine_batch: val,
                    }
                    : value_x
            )
        );
        try {
            axiosPrivate
                .get(`/data_entry/batch_number/?search=${val}`)
                .then((res) => {
                    setBatchDataArray(res.data);
                });
        } catch (e) {
            console.log(e);
        }
    };

    const displayDetailsHandler = (event, value, idx) => {
        setRowEditObject((current) =>
            current.map((value_x, index) =>
                index === idx
                    ? {
                        ...value_x,
                        medicine_batch: value['batch_number'],
                        medicine_name: value['description'],
                        medicine_master_id: value['medicine_master_id'],
                    }
                    : value_x
            )
        );
    }

    const styles = {
        column: {
            fontSize: "1em",
            fontFamily: "Montserrat",
            padding: "0.8em",
            textAlign: "center",
        },
        drop_down: {
            fontSize: "1em",
            fontFamily: "Montserrat",
            padding: "0",
            textAlign: "center",
        },
        header: {
            fontSize: "0.75em",
            padding: "0.4em",
            textAlign: "center",
            color: '#FFFFFF',
            backgroundColor: "#000000",
            fontFamily: "Montserrat",
        },
        button: {
            backgroundColor: "#0496C7",
            borderRadius: 6,
            color: '#fff',
            padding: '4px 20px'
        }
    }

    const quantityHandler = (value, idx) => {
        setRowEditObject((current) =>
            current.map((value_x, index) =>
                index === idx
                    ? {
                        ...value_x,
                        quantity: value,
                    }
                    : value_x
            )
        );
    }

    return (
        <>
            <TableRow
                style={
                    (() => {
                        switch (ent["Type"]) {
                            case "short":
                                return {
                                    backgroundColor: "rgba(255, 192, 0, 0.5)",
                                };
                            case "equal":
                                return {
                                    backgroundColor: "rgba(169, 208, 142, 0.72)",
                                };
                            case "excess":
                                return {
                                    backgroundColor: "rgba(255, 255, 0, 0.69)",
                                };
                            default:
                                return { backgroundColor: "foo" };
                        }
                    })()
                }
            >
                <TableCell style={styles.column}>{id + 1}</TableCell>
                <TableCell style={styles.column}>{ent["medicine_name"]}</TableCell>
                <TableCell style={styles.column}>{ent["Batch Number"]}</TableCell>
                <TableCell style={styles.column}>{ent["Claimed Quantity"]}</TableCell>
                <TableCell style={styles.column}>{ent["Scanned Quantity"]}</TableCell>
                {ent["Type"] === "short" ? (
                    <>
                        <TableCell style={styles.column}>{ent["Difference"]}</TableCell>
                        <TableCell style={styles.column}>0</TableCell>
                    </>
                ) : (
                    <>
                        <TableCell style={styles.column}>0</TableCell>
                        <TableCell style={styles.column}>{ent["Difference"]}</TableCell>
                    </>
                )}
                <TableCell style={styles.column}>{ent["Goods Type"]}</TableCell>
                <TableCell style={styles.column}>{ent["remark"]}</TableCell>
                <TableCell style={styles.drop_down}>
                    {(rowEditObject[0] !== null) &&
                        <IconButton onClick={handleExpand} padding={{ padding: '0px' }}>
                            <SvgMore style={{ padding: '0px' }} />
                        </IconButton>
                    }
                </TableCell>
            </TableRow>
            {expand && (rowEditObject[0] !== null) && (
                <TableRow>
                    <TableCell colSpan="10">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={styles.header}>Batch(Claim)</TableCell>
                                    <TableCell style={styles.header}>MEDICINE NAME(Claim)</TableCell>
                                    <TableCell style={styles.header}>QUANTITY(claim)</TableCell>
                                    <TableCell style={styles.header}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rowEditObject && rowEditObject.map((ele, idx) => (
                                    <TableRow>
                                        <TableCell style={styles.column}>
                                            <InputAutoComplet
                                                setValue={setRowEditObject}
                                                InputList={batchDataArray}
                                                inputValue={rowEditObject}
                                                APICall={APICall}
                                                displayDetailsHandler={displayDetailsHandler}
                                                placeholder='Batch Number'
                                                idx={idx}
                                                diaplayDropdown={['batch_number', 'description', 'date_of_expiry']}
                                            />
                                        </TableCell>
                                        <TableCell style={styles.column}>
                                            <TextInput
                                                value={ele?.medicine_name}
                                                isDisable={true}
                                            />
                                        </TableCell>
                                        <TableCell style={styles.column}>
                                            <NumberInput
                                                value={ele?.quantity}
                                                idx={idx}
                                                handler={quantityHandler}
                                            />
                                        </TableCell>
                                        <TableCell style={styles.column}>
                                            <Button variant="contained" style={styles.button} onClick={(event) => updateEvent(event, idx, rowEditObject)}>Update</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
};

export default ReconciledReportView;